module.exports = __webpack_public_path__ + "img/flash_charge_logo.dc9769b9.png";